<template>
  <HubContainer id="menuModifiersHub">

    <HubSection large icon="icon/hub/settings.svg"
                :title="$t('inventory.modifiers')"
                :description="$t('inventory.modifiers_description')"
                :buttonAction="goToModifiers">
    </HubSection>

    <HubSection large icon="icon/hub/inventory.svg"
                :title="$t('inventory.choices')"
                :description="$t('inventory.choices_description')"
                :buttonAction="goToChoices">
    </HubSection>


  </HubContainer>
</template>

<script>
import HubSection from "@/components/HubSection";
import HubContainer from "@/components/HubContainer";

export default {
  name: "MenuConfigurationHub",

  components: { HubSection, HubContainer },

  mounted() {
    this.$store.state.pageTitleTranslationKey = "inventory.selection";
    this.$store.state.pageIcon = "/icon/menu.svg";
  },

  methods: {
    goToModifiers() {
      this.$router.push(this.$router.buildContext("/modifiers"));
    },
    goToChoices() {
      this.$router.push(this.$router.buildContext("/choice-items"));
    }
  }
}
</script>